
const Group = {
    Execute(array, propoerty) {
        return array.reduce((grupos, item) => {
            const value = item[propoerty];
            grupos[value] = grupos[value] || [];
            grupos[value].push(item);
            return grupos;
        }, {});
    },

    Format(array) {
        let result = [];

        let labels = Object.keys(array);
        let values = Object.values(array);
        for (let index = 0; index < labels.length; index++) {
            if (labels[index] && labels[index].length > 0)
                result.push({ label: labels[index], value: values[index].length });
        }
        return result;
    }
};

export default Group;
